





















import Vue from "vue";

import Status from "@/components/execute/Status.vue";
import ImagePreview from "@/components/ImagePreview.vue";
import FileUpload from "@/components/FileUpload.vue";

import files from "@/fire/files";

export default Vue.extend({
  components: {
    Status,
    ImagePreview,
    FileUpload
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      step: this.value,
      uploading: false,
      preview: ""
    };
  },
  methods: {
    upload([file]: [File]) {
      this.uploading = true;
      this.preview = URL.createObjectURL(file);
      files.upload(file, "step/" + this.step.number).then(url => {
        Vue.set(this.step, "imageUrl", url);
        this.uploading = false;
        this.preview = "";
      });
    }
  }
});
